export const enum HotelSelectionModalType {
  None = 'none',
  PaxSelector = 'paxSelector',
  MobileFiltersModal = 'mobileFiltersModal',
  WhyWeSuggest = 'whyWeSuggest',
  DestinationSelector = 'destinationSelector',
  SemboBenefits = 'semboBenefits',
  PeekPrice = 'peekPrice',
}
